module.exports = __webpack_public_path__ + "67ccb43a216379efcaac9cc6272dca6b.svg";